import type {TrimFeatureAssignmentInput} from '@dms/api/new-vehicle';

type Inclusion = TrimFeatureAssignmentInput['inclusion'];

/**
 * A trim's full assignment set with `featureId` set to `inclusion`, appended when it is new. An
 * Optional item gets `priceNet`; Standard is included, so it carries no price, conditional price or
 * variant override (the backend refuses them).
 */
export const setTrimInclusion = (
  assignments: TrimFeatureAssignmentInput[],
  featureId: string,
  inclusion: Inclusion,
  priceNet: string | null
): TrimFeatureAssignmentInput[] => {
  const pricing =
    inclusion === 'STANDARD'
      ? {priceNet: null, priceIf: [], variantPriceOverrides: []}
      : {priceNet};
  return assignments.some((assignment) => assignment.featureId === featureId)
    ? assignments.map((assignment) =>
        assignment.featureId === featureId ? {...assignment, inclusion, ...pricing} : assignment
      )
    : [
        ...assignments,
        {
          featureId,
          inclusion,
          appliesIf: {anyOfVariantIds: [], allOfFeatureIds: []},
          priceIf: [],
          variantPriceOverrides: [],
          ...pricing,
          sortOrder: assignments.length,
        },
      ];
};
